//
// PrintSetup.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./ReportRendererSetup";
import "./particles/PrintOrientation";
import "./particles/PaperType";
import "./particles/PrintFitOption";
import "./particles/PrintTableOfContentsDisplayOption";
import "./particles/PrintDestination";

var PrintSetup = createModule("transport::PrintSetup", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel","transport::MediaType","transport::ReportRendererSetup"], EventDispatcher, [
    ,
    {
        showAppendix: 2,
        fitOption: 4,
        destination: 4,
        showPageNumbers: 2,
        locale: 7,
        marginRight: 7,
        utcOffsetInSeconds: 4,
        coverPageText: 7,
        formatterLocale: 7,
        showPrintedTableOfContents: 2,
        dpi: 4,
        paperHeight: 7,
        orientation: 4,
        paperType: 4,
        reportElements: 7,
        useHighContrastReportStyle: 2,
        tableOfContentsDisplay: 4,
        showCoverPage: 2,
        marginLeft: 7,
        paperWidth: 7,
        coverPageDateTime: 7,
        marginBottom: 7,
        appendixDisplay: 7,
        showEmptyRowsAndColumns: 2,
        marginTop: 7,
        enablePdfAccessibleTags: 2,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default PrintSetup;
